import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Radio.module.scss.js';

var Radio = forwardRef(function (_a, ref) {
    var _b;
    var value = _a.value, name = _a.name, checked = _a.checked, onChange = _a.onChange, ariaLabelledby = _a["aria-labelledby"], onFocus = _a.onFocus, onBlur = _a.onBlur, checkmarkClassName = _a.checkmarkClassName, disabled = _a.disabled, _c = _a.showRadio, showRadio = _c === void 0 ? true : _c;
    return (jsxs(Fragment, { children: [showRadio && (jsx("span", { className: clsx(styles.checkmark, (_b = {},
                    _b[styles.checkmarkChecked] = checked,
                    _b[styles.checkmarkDisabled] = disabled,
                    _b), checkmarkClassName) })), jsx("input", { className: styles.hiddenInput, id: value, checked: checked, type: "radio", name: name, value: value, onChange: onChange, "aria-labelledby": ariaLabelledby, ref: ref, onFocus: onFocus, onBlur: onBlur, disabled: disabled })] }));
});

export { Radio };
